import { gql } from "lib/apolloClient";

export const upsertTranscriptStudentCommentsMutation = gql`
  mutation UpsertTranscriptStudentComments(
    $input: [UpsertTranscriptStudentCommentsInput!]
  ) {
    transcript {
      upsertTranscriptStudentComments(input: $input) {
        isSuccess
        warning
      }
      __typename
    }
  }
`;

export const updateStudentPersonalDetailsMutation = gql`
  mutation UpsertTranscriptStudentBasicDetailFieldsMutation(
    $input: [UpsertTranscriptStudentBasicDetailFieldsInput!]
  ) {
    transcript {
      upsertTranscriptStudentBasicDetailFields(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateTranscriptStudentGradeCourseMappingMutation = gql`
  mutation UpdateTranscriptStudentGradeCourseMappingMutation(
    $input: UpdateTranscriptStudentGradeCourseMappingInput!
  ) {
    transcript {
      updateTranscriptStudentGradeCourseMapping(input: $input) {
        isSuccess
        warning
      }
      __typename
    }
  }
`;

export const upsertTranscriptStudentRatingsMutation = gql`
  mutation UpsertTranscriptStudentRatingsMutation(
    $input: [UpsertTranscriptStudentRatingsInput!]
  ) {
    transcript {
      upsertTranscriptStudentRatings(input: $input) {
        isSuccess
        warning
      }
      __typename
    }
  }
`;

export const syncPlatformGradeScaleForTranscriptsMutation = gql`
  mutation SyncPlatformGradeScaleForTranscripts(
    $input: SyncPlatformGradeScaleForTranscriptsInput!
  ) {
    transcript {
      syncPlatformGradeScaleForTranscripts(input: $input) {
        isSuccess
        warning
        gradeScales {
          id
          name
          sourceId
          sourceType
        }
        __typename
      }
      __typename
    }
  }
`;

export const updateTranscriptGradeScalesMutation = gql`
  mutation UpdateTranscriptGradeScales(
    $input: UpdateTranscriptGradeScalesInput!
  ) {
    transcript {
      updateTranscriptGradeScales(input: $input) {
        createdRecords {
          id
          name
          isCustom
          source {
            ... on GradeScale {
              id
              displayName
            }
          }
          associations {
            totalCount
          }
        }
        updatedRecords {
          id
          name
          isCustom
          source {
            ... on GradeScale {
              id
              displayName
            }
          }
          associations {
            totalCount
          }
        }
      }
    }
  }
`;

export const bulkCopyTranscriptConfigurationMutation = gql`
  mutation BulkCopyTranscriptConfigurationMutation(
    $input: BulkCopyTranscriptConfigurationInput!
  ) {
    transcript {
      bulkCopyTranscriptConfiguration(input: $input) {
        isSuccess
        warning
        __typename
      }
      __typename
    }
  }
`;

export const bulkCopyTranscriptGradingPeriodsMutation = gql`
  mutation BulkCopyTranscriptGradingPeriods(
    $sourceStudentId: ID!
    $targetStudentIds: [ID!]!
  ) {
    transcript {
      bulkCopyTranscriptGradingPeriods(
        input: {
          sourceStudentId: $sourceStudentId
          targetStudentIds: $targetStudentIds
        }
      ) {
        isSuccess
        warning
        applied {
          student {
            id
            firstName
            lastName
          }
          grades {
            id
            name
          }
        }
        skipped {
          student {
            id
            firstName
            lastName
          }
          errors {
            grades {
              id
              name
            }
            errorType
          }
        }
      }
    }
  }
`;

export const syncTranscriptStudentEntityMutation = gql`
  mutation SyncTranscriptStudentEntity(
    $input: [SyncTranscriptStudentEntityInput!]!
  ) {
    transcript {
      syncTranscriptStudentEntity(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateTranscriptConfigurationMutation = gql`
  mutation UpdateTranscriptConfigurationMutation(
    $input: [UpdateTranscriptConfigurationInput!]!
  ) {
    transcript {
      updateTranscriptConfiguration(input: $input) {
        isSuccess
        warning
        __typename
      }
      __typename
    }
  }
`;

export const updateTranscriptLevelsMutation = gql`
  mutation UpdateTranscriptLevelsMutation(
    $input: UpdateTranscriptLevelsInput!
  ) {
    transcript {
      updateTranscriptLevels(input: $input) {
        isSuccess
        warning
        createdRecords {
          id
          name
        }
        updatedRecords {
          id
          name
        }
      }
      __typename
    }
  }
`;

export const updateTranscriptCoursesMutation = gql`
  mutation UpdateTranscriptCoursesMutation(
    $input: UpdateTranscriptCoursesInput!
  ) {
    transcript {
      updateTranscriptCourses(input: $input) {
        isSuccess
        warning
        createdRecords {
          id
        }
      }
      __typename
    }
  }
`;

export const updateTranscriptGradingPeriodsMutation = gql`
  mutation updateTranscriptGradingPeriods(
    $input: UpdateTranscriptGradingPeriodsInput!
  ) {
    transcript {
      updateTranscriptGradingPeriods(input: $input) {
        isSuccess
        createdRecords {
          id
          name
          isCustom
          displaySequence
          source {
            ... on AcademicTerm {
              id
              curriculumProgram {
                id
              }
              academicYear {
                id
              }
            }
          }
          associations {
            totalCount
          }
        }
        updatedRecords {
          id
          name
          isCustom
          displaySequence
          source {
            ... on AcademicTerm {
              id
              curriculumProgram {
                id
              }
              academicYear {
                id
              }
            }
          }
          associations {
            totalCount
          }
        }
      }
    }
  }
`;

export const updateTranscriptStudentGradeGradingPeriodMappingMutation = gql`
  mutation updateTranscriptStudentGradeGradingPeriodMapping(
    $input: UpdateTranscriptStudentGradeGradingPeriodMappingInput!
  ) {
    transcript {
      updateTranscriptStudentGradeGradingPeriodMapping(input: $input) {
        isSuccess
      }
    }
  }
`;
